export const SERVICE_ACTION_COLLECTION_ICONS_FOLDER = 'service-action-collection';
